import { render, staticRenderFns } from "./OrderListGoodsNew.vue?vue&type=template&id=388ba6fb&scoped=true"
import script from "./OrderListGoodsNew.vue?vue&type=script&lang=js"
export * from "./OrderListGoodsNew.vue?vue&type=script&lang=js"
import style0 from "./OrderListGoodsNew.vue?vue&type=style&index=0&id=388ba6fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ba6fb",
  null
  
)

export default component.exports